import { useContext } from 'react'

import { InputPasswordContext } from '../contexts/input-password-context'

export function useInputPasswordProps() {
  const props = useContext(InputPasswordContext)
  return props
}
